import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	loadingMessageStart: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loadingMessageEnd: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loadingMessageStart: {
		id: 'jql-builder-basic.jql-editor.add-filter.loading-message-start',
		defaultMessage: 'Loading more filters',
		description: 'Screen reader message for loading more options in filter dropdown',
	},
	loadingMessageEnd: {
		id: 'jql-builder-basic.jql-editor.add-filter.loading-message-end',
		defaultMessage: 'Finished loading filters',
		description: 'Screen reader message when loading of options has finished in filter dropdown',
	},
});
export default messages;
